import { isDefined } from "@clipboard-health/util-ts";
import { type ShiftStateData } from "@src/appV2/Shifts/Shift/ShiftState/types";
import { isAfter, isSameMinute, parseISO, subMinutes } from "date-fns";

export interface ClockInTimingInfo {
  earliestClockInTime: Date | undefined;
  isAfterEarliestClockInTime: boolean;
  canClockInNow: boolean;
}

export function getClockInTimingInfo({
  shiftStart,
  shiftState,
  currentDate = new Date(),
}: {
  shiftStart: string;
  shiftState: ShiftStateData;
  currentDate?: Date;
}): ClockInTimingInfo {
  const shiftStartDate = parseISO(shiftStart);

  const earliestClockInTime = getEarliestClockInTime(shiftState, shiftStartDate);

  const isAfterEarliestClockInTime = isDefined(earliestClockInTime)
    ? isAfter(currentDate, earliestClockInTime) || isSameMinute(currentDate, earliestClockInTime)
    : false;

  return {
    earliestClockInTime,
    isAfterEarliestClockInTime,
    canClockInNow: isAfterEarliestClockInTime,
  };
}

function getEarliestClockInTime(
  shiftState: ShiftStateData,
  shiftStartDate: Date
): Date | undefined {
  if (shiftState.metadata.isEarlyClockInEnabled && isDefined(shiftStartDate)) {
    return subMinutes(shiftStartDate, shiftState.metadata.earlyClockInEnabledInMinutes ?? 0);
  }

  if (
    !shiftState.metadata.isEarlyClockInEnabled &&
    shiftState.metadata.isClockInPreregistrationEnabled &&
    isDefined(shiftStartDate)
  ) {
    return subMinutes(
      shiftStartDate,
      shiftState.metadata.clockInPreregistrationWindowInMinutes ?? 0
    );
  }

  return shiftStartDate;
}
